import { render, staticRenderFns } from "./PlayerManagementV3.vue?vue&type=template&id=4c1a6e98&scoped=true"
import script from "./PlayerManagementV3.vue?vue&type=script&lang=js"
export * from "./PlayerManagementV3.vue?vue&type=script&lang=js"
import style0 from "./PlayerManagementV3.vue?vue&type=style&index=0&id=4c1a6e98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1a6e98",
  null
  
)

export default component.exports